var render = function render(_c,_vm){return _c('span',{staticClass:"season-count"},[_vm._v(_vm._s(_vm.parent.$tc('misc.season', _vm.props.amount)))])
}
var staticRenderFns = []

export { render, staticRenderFns }